export default function DocumentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="50"
      viewBox="0 0 43 50"
      fill="none"
    >
      <path
        d="M27.4994 1H3.49741C2.96697 1 2.45826 1.21071 2.08319 1.58579C1.70812 1.96086 1.49741 2.46957 1.49741 3V47C1.49741 47.5304 1.70812 48.0392 2.08319 48.4142C2.45826 48.7893 2.96697 49 3.49741 49H39.4994C39.762 49 40.0221 48.9483 40.2647 48.8478C40.5074 48.7473 40.7279 48.5999 40.9136 48.4142C41.0993 48.2285 41.2466 48.008 41.3471 47.7654C41.4476 47.5227 41.4994 47.2626 41.4994 47V15M27.4994 1L41.4994 15M27.4994 1V15H41.4994M13.4994 35H29.4994M13.4994 27H29.4994"
        stroke="#AFBACA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
